import { setToken, removeToken } from "@/util/auth";
import { setStore, getStore } from "@/util/store";
import { isURL, validatenull } from "@/util/validate";
import { deepClone } from "@/util/util";
import webiste from "@/config/website";
import { Message } from "element-ui";
import {
  loginByUsername,
  loginBySocial,
  getUserInfo,
  getMenu,
  getTopMenu,
  logout,
  refreshToken,
  getButtons,
  loginByPhoneCode,
} from "@/api/user";

function addPath(ele, first) {
  const menu = webiste.menu;
  const propsConfig = menu.props;
  const propsDefault = {
    label: propsConfig.label || "name",
    path: propsConfig.path || "path",
    icon: propsConfig.icon || "icon",
    children: propsConfig.children || "children",
  };
  const icon = ele[propsDefault.icon];
  ele[propsDefault.icon] = validatenull(icon) ? menu.iconDefault : icon;
  const isChild =
    ele[propsDefault.children] && ele[propsDefault.children].length !== 0;
  if (!isChild) ele[propsDefault.children] = [];
  if (!isChild && first && !isURL(ele[propsDefault.path])) {
    ele[propsDefault.path] = ele[propsDefault.path] + "/index";
  } else {
    ele[propsDefault.children].forEach((child) => {
      addPath(child);
    });
  }
}

const user = {
  state: {
    userInfo: getStore({ name: "userInfo" }) || [],
    permission: getStore({ name: "permission" }) || {},
    roles: [],
    menu: getStore({ name: "menu" }) || [],
    menuAll: [],
    token: getStore({ name: "token" }) || "",
  },
  actions: {
    //根据用户名登录
    LoginByUsername({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginByUsername(
          userInfo.tenantId,
          userInfo.username,
          userInfo.password,
          userInfo.type,
          userInfo.key,
          userInfo.code
        )
          .then((res) => {
            const data = res.data.data;
            commit("SET_TOKEN", data.accessToken);
            commit("SET_USER_INFO", data);
            commit("DEL_ALL_TAG");
            commit("CLEAR_LOCK");
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    //根据第三方信息登录
    LoginBySocial({ commit }, userInfo) {
      return new Promise((resolve) => {
        loginBySocial(
          userInfo.tenantId,
          userInfo.source,
          userInfo.code,
          userInfo.state
        ).then((res) => {
          const data = res.data;
          if (data.success) {
            commit("SET_TOKEN", data.data.accessToken);
            commit("SET_REFRESH_TOKEN", data.data.refreshToken);
            commit("SET_USER_INFO", data.data);
            commit("DEL_ALL_TAG");
            commit("CLEAR_LOCK");
          } else {
            Message({
              message: data.msg,
              type: "error",
            });
          }
          resolve();
        });
      });
    },
    //根据手机号登录
    LoginByPhone({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginByPhoneCode(userInfo.phone, userInfo.code)
          .then((res) => {
            const data = res.data.data;
            console.log("res::", res);
            if (res.data.code === 200) {
              commit("SET_TOKEN", data.accessToken);
              commit("SET_USER_INFO", data);
              commit("DEL_ALL_TAG");
              commit("CLEAR_LOCK");
              resolve();
            } else {
              Message({
                message: data.msg,
                type: "error",
              });
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((res) => {
            const data = res.data.data;
            commit("SET_ROLES", data.roles);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    //刷新token
    RefreshToken({ state, commit }) {
      return new Promise((resolve, reject) => {
        refreshToken(state.refreshToken)
          .then((res) => {
            const data = res.data.data;
            commit("SET_TOKEN", data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 登出
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout()
          .then(() => {
            commit("SET_TOKEN", "");
            commit("SET_MENU", []);
            commit("SET_MENU_ALL", []);
            commit("SET_ROLES", []);
            commit("DEL_ALL_TAG");
            commit("CLEAR_LOCK");
            removeToken();
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    //注销session
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit("SET_TOKEN", "");
        commit("SET_MENU", []);
        commit("SET_MENU_ALL", []);
        commit("SET_ROLES", []);
        commit("DEL_ALL_TAG");
        commit("CLEAR_LOCK");
        removeToken();
        resolve();
      });
    },
    GetTopMenu() {
      return new Promise((resolve) => {
        getTopMenu().then((res) => {
          const data = res.data.data || [];
          resolve(data);
        });
      });
    },
    //获取系统菜单
    GetMenu({ commit, dispatch }, parentId) {
      return new Promise((resolve) => {
        getMenu(parentId).then((res) => {
          const data = res.data.data;
          // 手动添加页面
          const diyData = [
            // {
            //   name: '门店任务管理S',
            //   path: '/storeTaskManagements',
            //   application: 1,
            //   source: 'iconfont icon-shujuzhanshi2',
            //   children: [
            //     {
            //       name: '问卷基础设置',
            //       path: '/storeTaskManagements/questionnaireBasicSettings',
            //       sort: 3,
            //       source: 'iconfont icon-biaodan'
            //     }
            //   ]
            // },
            // {
            //   name: '报表',
            //   path: '/reportForms',
            //   application: 1,
            //   source: 'iconfont icon-shujuzhanshi2',
            //   children: [
            //     {
            //       name: '销量确认',
            //       path: '/reportForms/salesConfirm',
            //       sort: 3,
            //       source: 'iconfont icon-biaodan'
            //     }
            //   ]
            // },
            // {
            //   name: '内容管理',
            //   path: '/contentManage2',
            //   application: 1,
            //   source: 'iconfont icon-shujuzhanshi2',
            //   children: [
            //     {
            //       name: 'Banner管理',
            //       path: '/contentManage2/bannerManagement',
            //       sort: 3,
            //       source: 'iconfont icon-biaodan'
            //     },
            //     {
            //       name: '范围设置',
            //       path: '/contentManage2/rangeSettings',
            //       sort: 3,
            //       source: 'iconfont icon-biaodan'
            //     }
            //   ]
            // },
            // {
            //   name: '零售数据',
            //   path: '/retailData',
            //   application: 1,
            //   source: 'iconfont icon-shujuzhanshi2',
            //   children: [
            //     {
            //       name: '门店POS销售导入',
            //       path: '/retailData/storePosImport',
            //       sort: 1,
            //       source: 'iconfont icon-biaodan'
            //     },
            //     {
            //       name: '门店活动&奖励导入',
            //       path: '/retailData/storeActivityImport',
            //       sort: 2,
            //       source: 'iconfont icon-biaodan'
            //     },
            //     {
            //       name: '门店销售数据明细',
            //       path: '/retailData/storeSalesDataDetial',
            //       sort: 3,
            //       source: 'iconfont icon-biaodan'
            //     },
            //     {
            //       name: '门店销售数据汇总',
            //       path: '/retailData/storeSalesDataSummary',
            //       sort: 4,
            //       source: 'iconfont icon-biaodan'
            //     },
            //     {
            //       name: '零售数据导入设置',
            //       path: '/retailData/retailDataSet',
            //       sort: 5,
            //       source: 'iconfont icon-biaodan'
            //     },
            //     {
            //       name: '门店分配总金额设置',
            //       path: '/retailData/storeDistributionSet',
            //       sort: 6,
            //       source: 'iconfont icon-biaodan'
            //     }
            //   ]
            // },
            // {
            //   name: '考勤管理',
            //   path: '/attendanceManagements',
            //   application: 1,
            //   source: 'iconfont icon-shujuzhanshi2',
            //   children: [
            //     {
            //       name: '考勤规则设置',
            //       path: '/attendanceManagements/attendanceRuleSettings',
            //       sort: 1,
            //       source: 'iconfont icon-biaodan'
            //     },
            //     {
            //       name: '连续未打卡促销人员',
            //       path: '/attendanceManagements/nonClockingPersonnel',
            //       sort: 2,
            //       source: 'iconfont icon-biaodan'
            //     },
            //     {
            //       name: '考勤明细查看',
            //       path: '/attendanceManagements/attendanceDetails',
            //       sort: 3,
            //       source: 'iconfont icon-biaodan'
            //     },
            //     {
            //       name: '考勤汇总表',
            //       path: '/attendanceManagements/attendanceSummaryTable',
            //       sort: 4,
            //       source: 'iconfont icon-biaodan'
            //     },
            //     {
            //       name: '休假审批',
            //       path: '/attendanceManagements/leaveApproval',
            //       sort: 5,
            //       source: 'iconfont icon-biaodan'
            //     },
            //     {
            //       name: '补卡审批',
            //       path: '/attendanceManagements/cardReplacementApproval',
            //       sort: 6,
            //       source: 'iconfont icon-biaodan'
            //     },
            //     {
            //       name: '排店管理',
            //       path: '/attendanceManagements/storeManagement',
            //       sort: 7,
            //       source: 'iconfont icon-biaodan'
            //     },
            //     {
            //       name: '排店审批',
            //       path: '/attendanceManagements/storeApproval',
            //       sort: 8,
            //       source: 'iconfont icon-biaodan'
            //     },
            //   ]
            // },
          ];
          diyData.map((item) => {
            data.push(item);
          });

          let menu = deepClone(data);
          menu.forEach((ele) => {
            addPath(ele, true);
          });
          commit("SET_MENU", menu);
          commit("SET_MENU_ALL", menu);
          dispatch("GetButtons");
          resolve(menu);
        });
      });
    },
    GetButtons({ commit }) {
      return new Promise((resolve) => {
        getButtons().then((res) => {
          const data = res.data.data;
          commit("SET_PERMISSION", data);
          resolve();
        });
      });
    },
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      setToken(token);
      state.token = token;
      setStore({ name: "token", content: state.token, type: "session" });
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
      setStore({ name: "userInfo", content: state.userInfo });
    },
    SET_MENU_ALL: (state, menuAll) => {
      state.menuAll = menuAll;
      setStore({ name: "menuAll", content: state.menuAll, type: "session" });
    },
    SET_MENU: (state, menu) => {
      state.menu = menu;
      setStore({ name: "menu", content: state.menu, type: "session" });
      if (validatenull(menu)) return;
      //合并动态路由去重
      let menuAll = state.menuAll;
      menuAll = menuAll.concat(menu).reverse();
      let newMenu = [];
      for (let item1 of menuAll) {
        let flag = true;
        for (let item2 of newMenu) {
          if (item1.name === item2.name || item1.path === item2.path) {
            flag = false;
          }
        }
        if (flag) newMenu.push(item1);
      }
      state.menuAll = newMenu;
      setStore({ name: "menuAll", content: state.menuAll, type: "session" });
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_PERMISSION: (state, permission) => {
      let result = [];

      function getCode(list) {
        list.forEach((ele) => {
          if (typeof ele === "object") {
            const chiildren = ele.children;
            const code = ele.code;
            if (chiildren) {
              getCode(chiildren);
            } else {
              result.push(code);
            }
          }
        });
      }

      getCode(permission);
      state.permission = {};
      result.forEach((ele) => {
        state.permission[ele] = true;
      });
      setStore({
        name: "permission",
        content: state.permission,
        type: "session",
      });
    },
  },
};
export default user;
